<template>
  <div>
    <v-card class="ma-4 word_keeper">
      <v-toolbar dense flat color="white">
        <v-toolbar-title class="font-weight-bold" style="min-width:140px;">
          <v-icon class="mr-2">mdi-square-edit-outline</v-icon>방문예약 신청
        </v-toolbar-title>
      </v-toolbar>
      <v-divider class="ml-4 mr-4"></v-divider>
      <v-toolbar dense flat color="white" class="text-truncate">
        <v-card-subtitle class="grey--text text--darken-2 text-subtitle-1 font-weight-bold pa-0">
          {{$store.state.CustomInfo.SiteNm}} 담당자
        </v-card-subtitle>
        <div class="ml-2 text-caption grey--text text--darken-2 font-weight-bold hidden-sm-and-down">
          <div>방문예약은 업무상 출입이 필요한 외부인만 가능합니다.(개인용무 시 예약불가)</div>
          <div class="mt-n1">사전에 {{$store.state.CustomInfo.SiteNm}} 담당자와 협의하여 접견실만 이용할 경우 방문예약은 따로 신청하지 않아도 됩니다.</div>
        </div>
      </v-toolbar>
      <v-card-text class="hidden-md-and-up pb-0 pt-0 text-caption grey--text text--darken-2 font-weight-bold text-justify">
        <div>방문예약은 업무상 출입이 필요한 외부인만 가능합니다.(개인용무 시 예약불가)</div>
        <div class="mt-n1">사전에 {{$store.state.CustomInfo.SiteNm}} 담당자와 협의하여 접견실만 이용할 경우 방문예약은 따로 신청하지 않아도 됩니다.</div>
      </v-card-text>
      <v-card outlined tile class="ma-4 essetial_card">
        <v-card-text class="pt-6 pb-0">
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <div class="d-flex">
                <v-text-field ref="ChargeInfoRef" v-model="zChargeInfo.cEmailAddr1" @keyup="ResetEmailInfo()" @keyup.enter="GetChargeInfo()" class="mr-2" dense persistent-placeholder>
                  <template v-slot:label>
                    담당자 이메일<strong class="red--text">*</strong>
                  </template>
                </v-text-field>
                <v-select v-model="zChargeInfo.cEmailAddr2" :items="zEmaillAddr" @click:append-outer="GetChargeInfo()" append-outer-icon="search" auto-select-first dense style="width:160px;">
                  <template v-slot:prepend>
                    <div>@</div>
                  </template>
                </v-select>
              </div>
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <v-text-field v-model="zChargeInfo.cUserNm" readonly label="담당자 이름" dense persistent-placeholder></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-divider class="ml-4 mr-4"></v-divider>
      <v-toolbar dense flat color="white" class="text-truncate">
        <v-card-subtitle class="grey--text text--darken-2 text-subtitle-1 font-weight-bold pa-0">
          방문자 정보
        </v-card-subtitle>
        <div class="ml-2 text-caption grey--text text--darken-2 font-weight-bold hidden-sm-and-down">
          <div>일반방문의 경우 방문증은 발급 받은 당일에 한해 유효하며, 업무 종료 시 즉시 반납 바랍니다.</div>
          <!-- 0806 수정 -->
          <div v-if="CustomInfo.SiteId == 'SKST'" class="mt-n1">장기출입의 경우 방문기간이 종료되는 당일 출문 시 반드시 반납하여야 합니다.(발급 후 24시간 이내 미반납 시 산업 보안 규정 위반으로 조치됨)<br></div>
          <div v-else class="mt-n1"> 장기출입의 경우도 방문증은 출문 시에 반드시 반납하여야 합니다.<br></div>
        </div>
      </v-toolbar>
      <!-- 0806 수정 -->
      <v-card-text v-if="CustomInfo.SiteId == 'SKST'" class="hidden-md-and-up pb-0 pt-0 text-caption grey--text text--darken-2 font-weight-bold text-justify">
        일반방문의 경우 방문증은 발급 받은 당일에 한해 유효하며, 업무 종료 시 즉시 반납 바랍니다.<br>
        장기출입의 경우 방문기간이 종료되는 당일 출문 시 반드시 반납하여야 합니다.(발급 후 24시간 이내 미반납 시 산업 보안 규정 위반으로 조치됨)
      </v-card-text>
      <v-card-text v-else class="hidden-md-and-up pb-0 pt-0 text-caption grey--text text--darken-2 font-weight-bold text-justify">
        일반방문의 경우 방문증은 발급 받은 당일에 한해 유효하며, 업무 종료 시 즉시 반납 바랍니다.<br>
        장기출입의 경우도 방문증은 출문 시에 반드시 반납하여야 합니다.
      </v-card-text>
      <v-card outlined tile class="ma-4">
        <v-card-text class="pt-6 pb-0">
          <v-row>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="CustomInfo.CustomNm" label="방문자이름" dense disabled persistent-placeholder></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="CustomInfo.Email" label="이메일" dense disabled persistent-placeholder></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-if="CustomInfo.Local == 'Y'" v-model="CustomInfo.CorpNmKor" label="소속 업체명" dense disabled persistent-placeholder></v-text-field>
              <v-text-field v-else v-model="CustomInfo.CorpNmEng" label="소속 업체명" dense disabled persistent-placeholder></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="CustomInfo.LevNm" label="직책" dense disabled persistent-placeholder></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="CustomInfo.Tel" label="휴대전화번호" dense disabled persistent-placeholder></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="CustomInfo.National" label="국적" dense disabled persistent-placeholder></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card outlined tile class="ma-4 essetial_card">
        <v-card-text class="pt-6 pb-0">
          <v-row class="mb-0">
            <v-col cols="12" sm="6" md="3" v-if="CustomInfo.SiteId != 'SKMA' && CustomInfo.SiteId != 'SKMG14' && CustomInfo.SiteId != 'SKTC'">
              <v-select
                v-model="editedItem.cSort"
                :items="zSort"
                @change="DisableSelect()"
                placeholder="::선택하세요::"
                dense
                persistent-placeholder>
                <template v-slot:label>
                  구분<strong class="red--text">*</strong>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <IronDate v-model="editedItem.sNowSelectDate" :bSelect="editedItem.cSort == '0'?true :false" :sMinDate="sToday" @overmaxperiod="overmaxperiod" @update="onDateRangeChange" ref="IronDateRef" cLabelEs="방문일" style="width:100%;"/>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-select
                v-model="editedItem.cPurpose"
                :items="zPurPose"
                @change="editedItem.cSubPurpose = '';"
                placeholder="::선택하세요::"
                v-if="editedItem.cPurpose != '직접입력'"
                dense
                return-object
                persistent-placeholder
                class=""
              >
                <template v-slot:label>
                  방문목적<strong class="red--text">*</strong>
                </template>
              </v-select>
              <v-text-field
                v-model="editedItem.cDirPurpose"
                v-if="editedItem.cPurpose == '직접입력'"
                @click:append="editedItem.cDirPurpose = '';editedItem.cPurpose = '회의'"
                dense
                class=""
                append-icon="refresh"
                persistent-placeholder
                placeholder="직접입력"
              >
                <template v-slot:label>
                  방문목적<strong class="red--text">*</strong>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field ref="SubPurposeRef" v-model="editedItem.cSubPurpose" :disabled="editedItem.cPurpose == '직접입력'" :class="{'' : editedItem.cPurpose != '직접입력'}" dense persistent-placeholder>
                <template v-slot:label>
                  <div>방문목적 상세설명<strong v-if="editedItem.cPurpose != '직접입력'" class="red--text">*</strong></div>
                </template>
              </v-text-field>
            </v-col>
           
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="editedItem.cZone" @click:append-outer="ShowMapDialog()" append-outer-icon="map" class="" dense readonly persistent-placeholder>
                <template v-slot:label>
                  방문장소<strong class="red--text">*</strong>
                </template>
              </v-text-field>
            </v-col>
            <!-- <v-col cols="12" sm="6" md="3" v-if="cDefaultSiteMap == ''">
              <v-text-field v-model="editedItem.cZone" @click:append-outer="ShowMapDialog()" append-outer-icon="map" class="" dense readonly persistent-placeholder>
                <template v-slot:label>
                  방문장소<strong class="red--text">*</strong>
                </template>
              </v-text-field>
            </v-col> -->
            <v-col cols="12" sm="6" md="3">
              <v-btn @click="SetAddWorker()" style="width:100%" dark><v-icon class="mr-2">mdi-account-multiple-plus-outline</v-icon>방문자 선택</v-btn>
              <!-- <v-text-field v-model="editedItem.cWorkerList" @click:append-outer="SetAddWorker()" label="방문자 선택" append-outer-icon="mdi-account-multiple-plus-outline" readonly dense persistent-placeholder></v-text-field> -->
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-divider class="ml-4 mr-4"></v-divider>
      <v-toolbar dense flat color="white" class="text-truncate">
        <v-card-subtitle class="grey--text text--darken-2 text-subtitle-1 font-weight-bold pa-0">
          차량 정보
        </v-card-subtitle>
        <div class="ml-2 text-caption grey--text text--darken-2 font-weight-bold hidden-sm-and-down" v-if = "$store.state.CustomInfo.SiteId =='SKMG14'">
          <div>납품 및 공사차량만 출입 가능</div>
        </div>
        <div class="ml-2 text-caption grey--text text--darken-2 font-weight-bold hidden-sm-and-down" v-if = "$store.state.CustomInfo.SiteId =='SKTC'">
          <div>당사를 방문하는 차량은 차량 4면에 업체명을 부착(가로 20cm 이상)하고, 차량 앞 유리 운전자 휴대폰번호를 표기하여야 합니다.</div>
        </div>
        <v-spacer></v-spacer>
        <v-btn @click="zCarInfo.splice(-1,1);" class="font-weight-bold" small dark width="100px"><v-icon small class="mr-1">mdi-minus</v-icon><div class="text-caption">차량 삭제</div></v-btn>
        <v-btn @click="zCarInfo.push({CarType: '',CarNo: ''});" class="font-weight-bold ml-2" small dark width="100px"><v-icon small class="mr-1">mdi-plus</v-icon><div class="text-caption">차량 추가</div></v-btn>
      </v-toolbar>
      <v-card outlined tile class="ma-4 essetial_card">
        <v-card-text class="pt-6 pb-0">
          <v-row class="mb-0">
            <v-col cols="12" sm="6" md="6" v-for="(item,index) in zCarInfo" :key="index">
              <div class="d-flex justify-space-between">
                <v-text-field v-model="item.CarType" class="mr-3" label="차종" dense persistent-placeholder></v-text-field>
                <v-text-field v-model="item.CarNo" class="ml-3" label="차량번호" dense persistent-placeholder></v-text-field>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <div v-if = "$store.state.CustomInfo.SiteId =='SKMP'">
        <v-divider class="ml-4 mr-4"></v-divider>
        <v-toolbar dense flat color="white" class="text-truncate">
          <v-card-subtitle class="grey--text text--darken-2 text-subtitle-1 font-weight-bold pa-0">
            요청사항
          </v-card-subtitle>        
        </v-toolbar>
        
        <v-textarea v-model="editedItem.cReqMsg" outlined class="ma-3 mt-n2 mb-n4" label="" placeholder="요청사항을 입력하세요." dense persistent-placeholder></v-textarea>        
      </div>
      
      <v-divider class="ma-4 mt-2"></v-divider>
      <v-card-text align="center" class="pt-0">
        <v-btn @click="$router.push({name: 'MainBoard'});" text class="mr-2"><v-icon class="mr-2">dashboard</v-icon>홈</v-btn>
        <v-btn @click="SetReqLog()" dark class="ml-2"><v-icon class="mr-2">post_add</v-icon>신청</v-btn>
      </v-card-text>
    </v-card>


    <v-card class="ma-4">
      <v-toolbar dense flat color="white">
        <v-toolbar-title class="font-weight-bold">
          <v-icon class="mr-2 mt-n1">mdi-account-group-outline</v-icon>방문자 리스트
        </v-toolbar-title>
      </v-toolbar>
      <v-divider class="ml-4 mr-4"></v-divider>
      <v-card-text class="pb-0">
        <v-data-table
          :headers="getHeader()"
          :items="zWorker"
          :items-per-page="15"
          height="781px"
          item-key="cCustomId"
          fixed-header>
          <template v-slot:item.cEdit="{ item }">
            <v-btn @click="ShowDelDialog(item)" icon><v-icon>delete</v-icon></v-btn>
          </template>

          <template v-slot:item.cEmployeeTrainingFileId="{ item }">
            <div class="center_all" style="width:100%;">
              <div class="d-flex">
                <v-btn v-if="item.cEmployeeTrainingFileId == 'NONE'" @click="AddEmployeeTrainingFileId(item)" icon>
                  <v-icon >mdi-paperclip-plus</v-icon>                  
                </v-btn>  
                <v-btn v-else @click="AddEmployeeTrainingFileId(item)">                  
                  <v-icon >mdi-paperclip</v-icon>변경
                </v-btn>  
                <div v-if="item.cEmployeeTrainingFileId != 'NONE'" class="d-flex">                  
                  <v-text-field class="ml-2 mb-n8" style="width:140px; height:20px; margin-top: -3px;" 
                    outlined v-model="item.cEmployeeTrainingDate" label="" dense persistent-placeholder                    
                    append-icon="mdi-calendar"
                    readonly
                    @click:append="GetEmployeeTrainingDate(item)"
                    placeholder="이수증일자"></v-text-field>
                  <v-text-field class="ml-1 mb-n8" style="width:120px; height:20px; margin-top: -3px;" 
                    outlined v-model="item.cEmployeeTrainingNum" label="" dense persistent-placeholder 
                    placeholder="이수증번호" @input="onInputChange(item)"
                    ></v-text-field>
                  <v-btn class="ml-n2" @click="DelEmployeeTrainingFileId(item)" icon><v-icon>mdi-paperclip-remove</v-icon></v-btn>                
                </div>
                <div v-else>
                  <v-btn class="ml-2" @click="downloadPage()"><v-icon class="mr-1">mdi-open-in-new</v-icon>이수증 다운로드</v-btn>
                </div>
              </div>
            </div>
          </template>
          <template v-slot:item.cConstructionFileId="{ item }">
            <div class="center_all" style="width:100%;">
              <div class="d-flex">
                <v-btn v-if="item.cConstructionFileId == 'NONE'" @click="AddConstructionFileId(item)" icon>
                  <v-icon >mdi-paperclip-plus</v-icon>
                </v-btn>  
                <v-btn v-else @click="AddConstructionFileId(item)">                  
                  <v-icon >mdi-paperclip</v-icon>변경
                </v-btn>  
                <div v-if="item.cConstructionFileId != 'NONE'" class="d-flex">                  
                  <v-text-field class="ml-2 mb-n8" style="width:140px; height:20px; margin-top: -3px;" 
                    outlined v-model="item.cConstructionDate" label="" dense persistent-placeholder                    
                    append-icon="mdi-calendar"
                    readonly
                    @click:append="GetConstructionDate(item)"
                    placeholder="이수증일자"></v-text-field>
                  <v-btn class="ml-n2" @click="DelConstructionFileId(item)" icon><v-icon>mdi-paperclip-remove</v-icon></v-btn>                
                </div>
                <!-- <div v-if="item.cConstructionFileId != 'NONE'" class="d-flex">                                    
                  <v-btn class="ml-0" @click="DelConstructionFileId(item)" icon><v-icon>mdi-paperclip-remove</v-icon></v-btn>                
                </div> -->
              </div>
            </div>
          </template>
          <template v-slot:no-data>
            <div class="black--text">추가된 방문자가 존재하지 않습니다.</div>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <!-- <v-card class="ma-4">
      <v-toolbar dense flat color="white">
        <v-toolbar-title class="font-weight-bold">
          <v-icon class="mr-2 mt-n1">mdi-format-list-bulleted-square</v-icon>최근 방문예약 신청현황
        </v-toolbar-title>
      </v-toolbar>
      <v-divider class="ml-4 mr-4"></v-divider>
      <v-card-text class="pb-0">
        <v-data-table
          :headers="headers"
          :items="Records"
          v-model="selected"
          :single-select="bSingleSelect"
          @click:row="handleClick"
          @dblclick:row="handleDoubleClick(selected[0])"
          :items-per-page="15"
          height="781px"
          item-key="cReqId"
          fixed-header
        >
          <template v-slot:item.cCreateDateTime="{ item }">
            {{item.cCreateDateTime.substring(0,10)}}
          </template>
          <template v-slot:item.cSort="{ item }">
            <v-chip label small :color="getSortColor(item.cSort)" dark>{{ getSort(item.cSort) }}</v-chip>
          </template>
          <template v-slot:item.cVisitDate="{ item }">
            <div>{{getDate(item)}}</div>
          </template>
          <template v-slot:item.cZone="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div
                  style="max-width:220px;min-width:150px;"
                  class="text-truncate"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{item.cZone}}
                </div>
              </template>
              <div style="max-width:300px !important;">{{item.cZone}}</div>
            </v-tooltip>
          </template>
          <template v-slot:item.cPurpose="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div
                  style="max-width:220px;min-width:70px;"
                  class="text-truncate"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{item.cPurpose}}
                </div>
              </template>
              <div style="max-width:300px !important;">{{item.cPurpose}}</div>
            </v-tooltip>
          </template>
          <template v-slot:item.sCar="{ item }">
            {{item.cCarType}}&nbsp;{{item.cCarNo}}
          </template>
          <template v-slot:item.cState="{ item }">
            <v-chip label small :color="getStateColor(item.cState)" dark>{{ getState(item.cState) }}</v-chip>
          </template>
          <template v-slot:item.cEndComment="{ item }">
            <v-btn v-if="((item.cCustomId == CustomInfo.CustomId) || (item.cCorpId == CustomInfo.CorpId && CustomInfo.Manager != 'N')) && item.cState != 'REQ'" @click="ShowComment(item,item.cState)" icon><v-icon>mdi-account-details-outline</v-icon></v-btn>
          </template>
          <template v-slot:item.cEdit="{ item }">
            <div v-if="item.cCustomId == CustomInfo.CustomId && item.cState == 'REQ'" class="d-flex">
              <v-btn @click="OpenDialog(item)" icon><v-icon>mdi-pencil</v-icon></v-btn>
              <v-btn @click="ShowDelDialog(item)" icon><v-icon>delete</v-icon></v-btn>
            </div>
          </template>
          <template v-slot:no-data>
            <div class="black--text">조회 결과가 없습니다.</div>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card> -->


    <MapDialog ref="MapDialogRef" @SetMap="SetMap"/>
    <!-- <EditDialog ref="EditDialogRef" @ChangeReq="ChangeReq"/> -->
    <!-- <DelDialog ref="DelDialogRef" @DelData="DelData"/> -->
    <ResponseDialog ref="ResponseDialogRef"/>
    <AddWorkerDialog ref="AddWorkerDialogRef" :bLongVisit="editedItem.cSort == '0' ? false : true" @onSelect="SelectWorker"/>

    <v-dialog v-model="bShowMsg" max-width="500" persistent>
      <v-card>
        <v-card-title class="headline font-weight-bold">
          <div>장기 출입시 증명사진이 필요합니다.</div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-5">
          <div>증명사진의 첨부가 누락되었습니다.</div>
          <div>{{ (30-cCircularTime)/10 }} 초후 정보 수정 화면으로 이동합니다.</div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isDate" width="290px">
      <v-card style="height: 440px;">
        <!-- <v-date-picker></v-date-picker> -->
        <v-date-picker
          color="black" 
          show-adjacent-months
					v-model="pickerDate"
					locale="ko"
					:day-format="(date) => new Date(date).getDate()">
					</v-date-picker>

        <div class="d-flex ma-3 mb-5">
          <v-spacer></v-spacer>
          <v-btn @click="isDate = false">취소</v-btn>
          <v-btn class="ml-2" @click="setDate()"><v-icon>mdi-check</v-icon> 확인</v-btn>
        </div>
      </v-card>
    </v-dialog>
    

    <input
      type="file"
      ref="fileInput"
      accept=".jpg,.jpeg,.png,.pdf"
      style="display: none;"
      @change="onFileSelected"
    />
  </div>
</template>

<script>
import axios from "axios"
// import BasicInfo from "@/BasicInfo.js";
import EventBus from '@/eventBus.js';
import { mapState } from "vuex";

import IronDate from '@/components/iron28Calendar/src/IronDate4.vue';

import Util from "../Util.js";

import MapDialog from "../components/MapDialog.vue";
// import EditDialog from "../components/EditDialog.vue";
// import DelDialog from "../components/DelDialog.vue";
import ResponseDialog from "../components/ResponseDialog.vue";
import AddWorkerDialog from "../components/AddWorkerDialog.vue";

export default {
  components: {
    IronDate,
    MapDialog,
    // EditDialog,
    // DelDialog,
    ResponseDialog,
    AddWorkerDialog,
  },

  data: () => ({    
    isConstructionMode : false,
    cDefaultSiteMap : "",
    NowSelFile: null, 
    timeoutId: null, 
    SelItem : null,
    pickerDate : "",
    dateType: '',
    isDate : false,
    bShowMsg : false,
    // bSingleSelect : true,
    sToday : new Date(),
    cCircularTime : 0,
    interval : {},
    zWorker : [
      // {cCustomId:"58DB33-C13E-BBD0", sNum : "1",  cEmployeeTrainingFileId : "111", cEmployeeTrainingDate : "2024-12-12", cEmployeeTrainingNum : "1234", cConstructionFileId : "1111",},
      // {cCustomId:"58DB33-C13E-BBD1", sNum : "2",  cEmployeeTrainingFileId : "111", cEmployeeTrainingDate : "2024-12-12", cEmployeeTrainingNum : "1234", cConstructionFileId : "1111",}
    ],
    zCarInfo : [],
    editedItem : {
      cPurpose : "회의",
      cReqMsg : "",
      cSubPurpose : "",
      cDirPurpose : "",
      cState : "ALL",
      cSort : "1",
      sNowSelectDate :  Util.sFormatDate(Date()) + " ~ " +  Util.sFormatDate(Util.sTomorrowSel()),
      cStartDate : Util.sFormatDate(Date()),
      cEndDate : Util.sFormatDate(Util.sTomorrowSel()),
      cZone : "",
      cCarType : "",
      cCarNo : "",
      // cWorkerList : "",
    },
    defaultItem : {
      cPurpose : "회의",
      cReqMsg : "",
      cSubPurpose : "",
      cDirPurpose : "",
      cState : "ALL",
      cSort : "1",
      sNowSelectDate :  Util.sFormatDate(Date()) + " ~ " +  Util.sFormatDate(Util.sTomorrowSel()),
      cStartDate : Util.sFormatDate(Date()),
      cEndDate : Util.sFormatDate(Util.sTomorrowSel()),
      cZone : "",
      cCarType : "",
      cCarNo : "",
      // cWorkerList : "",
    },

    zChargeInfo : {
      cUserId: "",
      cUserNm :  "",
      cEmailAddr1 : "",
      cEmailAddr2 : "",
    },

    selected : [],
    zMapZoneInfo : [],
    // Records : [],
    // headers : [
    //   { text: 'NO', align: 'start', value: 'sNum',width:"10"},
    //   { text: '신청일자', align: 'start', value: 'cCreateDateTime',width:"120"},
    //   { text: '구분', align: 'start', value: 'cSort',width:"80"},
    //   { text: '방문일', value: 'cVisitDate',width:"210"},
    //   { text: '방문장소', value: 'cZone'},
    //   { text: '방문목적', value: 'cPurpose'},
    //   { text: '차량번호', value: 'sCar',width:"170"},
    //   { text: '담당자', value: 'cChargeUserNm',width : "80"},
    //   { text: '상태', value: 'cState', width:"80", align : "center"},
    //   { text: '의견', value: 'cEndComment',width:"80",align : "center"},
    //   { text: '작업', value: 'cEdit', width:"80", align : "center"},
    // ],
    headers_SKST : [
      { text: 'NO', align: 'start', value: 'sNum',width:"10"},
      { text: '방문직원', value: 'CustomNm', align: 'center',width:"100"},
      { text: '이메일', value: 'Email', align: 'center'},
      { text: '전화번호', value: 'Tel', align: 'center'},
      { text: '직책', value: 'LevNm', align: 'center'},
      { text: '작업', value: 'cEdit', align : "center"},
    ],
    headers_SKMG14 : [
      { text: 'NO', align: 'start', value: 'sNum',width:"10"},
      { text: '방문직원', value: 'CustomNm', align: 'center',width:"100"},
      { text: '이메일', value: 'Email', align: 'center'},
      { text: '전화번호', value: 'Tel', align: 'center'},
      { text: '직책', value: 'LevNm', align: 'center'},
      { text: '종사자 교육 이수증', value: 'cEmployeeTrainingFileId', align: 'center', width:450},
      { text: '건설업 기초안전보건교육 이수증', value: 'cConstructionFileId', align: 'center'},
      { text: '작업', value: 'cEdit', align : "center"},
    ],
  }),
  computed: {
    ...mapState(["CustomInfo","zPurPose","zSort","zState","zEmaillAddr"]),
  },

  created() {

  },

  mounted() {
    // this.GetReqLog();
    


    this.cDefaultSiteMap = this.getDefaultSiteMap();
    
    this.init();
  },

  beforeDestroy () {
    clearInterval(this.interval)
  },

  methods : {
    getDefaultSiteMap() {
      for (let i = 0; i < this.$store.state.zSite.length; i++) {
        if (this.$store.state.zSite[i].id == this.$store.state.CustomInfo.SiteId) {
          return this.$store.state.zSite[i].defaultMap;
        }       
      }
      return "";
    },
    

    getHeader(){
      if (this.CustomInfo.SiteId == "SKMG14" || this.CustomInfo.SiteId == "SKTC") {
        return this.headers_SKMG14;
      }
      return this.headers_SKST;
    },
    init() {
      // this.editedItem.cCarType = this.CustomInfo.CarType
      // this.editedItem.cCarNo = this.CustomInfo.CarNo
      this.zChargeInfo.cUserId = ""
      this.zChargeInfo.cUserNm = ""
      this.zChargeInfo.cEmailAddr1 = ""
      this.zChargeInfo.cEmailAddr2 = this.zEmaillAddr[0]
      this.zCarInfo = []
      this.zCarInfo.push({CarType : this.CustomInfo.CarType,CarNo :this.CustomInfo.CarNo})


      if (this.CustomInfo.SiteId == "SKMA") {
        this.editedItem.cSort = '1';
      }
    },

    CountTime() {
      this.interval = setInterval(() => {
        this.cCircularTime += 10
      }, 1000)
    },

    ResetEmailInfo(){
      this.zChargeInfo.cUserId = ""
      this.zChargeInfo.cUserNm = ""
    },

    GetChargeInfo(){
      var posData = {
        SiteId : this.CustomInfo.SiteId,
        CustomId : this.CustomInfo.CustomId,
        Email : this.zChargeInfo.cEmailAddr1 + "@" +this.zChargeInfo.cEmailAddr2,
      };
      axios
        .post(process.env.VUE_APP_UIL_API + "GetChargeInfo", posData, {
          headers: {
           "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd === "00") {
            if (res.data.Result.length == 0) {
              EventBus.$emit("onShowMsgBox","입력하신 이메일을 다시 확인하여 주세요.","입력하신 이메일과 일치하는 담당자가 없습니다.");
            } else {
              this.zChargeInfo.cUserId = res.data.Result[0].cUserId
              this.zChargeInfo.cUserNm = res.data.Result[0].cUserNm
            }
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);        
        });
    },

    ShowMapDialog(){
      this.$refs.MapDialogRef.ShowDialog(this.zMapZoneInfo)
    },

    SetMap(zZone,zZoneNm){
      this.zMapZoneInfo = zZone
      this.editedItem.cZone = zZoneNm
    },

    ShowDelDialog(item){
      let AddIndex = this.zWorker.indexOf(item)
      if (AddIndex != -1) {
        this.zWorker.splice(AddIndex, 1);
      }

      for (let i = 0; i < this.zWorker.length; i++) {
        this.zWorker[i].sNum = i + 1
      }

      EventBus.$emit("onShowMsg",false,  "목록에서 제외 되었습니다.");
    },
    
    // DelData(index,item){
    //   this.DelReqLog(index,item)
    // },

    overmaxperiod(value){
      EventBus.$emit("onShowMsgBox", value.sTitle,value.sMsg);
    },

    // 날짜 변경하기
    onDateRangeChange(daterange){
      this.editedItem.cStartDate = Util.sFormatDate(daterange.startDate);
      this.editedItem.cEndDate = Util.sFormatDate(daterange.endDate);
      this.editedItem.cEndDate == this.editedItem.cStartDate ? this.editedItem.cSort = "0": this.editedItem.cSort = "1"
      this.editedItem.cSort == "0"?this.editedItem.sNowSelectDate = this.editedItem.cStartDate:this.editedItem.sNowSelectDate = this.editedItem.cStartDate + " ~ " +  this.editedItem.cEndDate
      this.zWorker = []
    },
    
    DisableSelect(){
      if (this.editedItem.cSort == "0") {
        this.editedItem.cEndDate = this.editedItem.cStartDate;
        this.editedItem.sNowSelectDate = this.editedItem.cStartDate
      } else {
        this.editedItem.cStartDate = Util.sFormatDate(Date());
        this.editedItem.cEndDate = Util.sFormatDate(Util.sTomorrowSel());
        this.editedItem.sNowSelectDate = this.editedItem.cStartDate + " ~ " +  this.editedItem.cEndDate;
      }
      // this.editedItem.cWorkerList = "";
      this.zWorker = [];
    },

    // getStateColor(cState){
    //   return this.zState.find((e) => {return e.value == cState})?.color
    // },

    // getState(cState){
    //   return this.zState.find((e) => {return e.value == cState})?.text
    // },

    // getSortColor(cSort){
    //   return this.zSort.find((e) => {return e.value == cSort})?.color
    // },

    // getSort(cSort){
    //   return this.zSort.find((e) => {return e.value == cSort})?.text
    // },

    // getDate(item){
    //   if (item.cSort == "1") {
    //     return item.cStartDate.substring(0,10) + " ~ " + item.cEndDate.substring(0,10)
    //   } else {
    //     return item.cStartDate.substring(0,10)
    //   }
    // },

    // GetReqLog(){
    //   var posData = {};

    //   posData = {
    //     Manager : "N",
    //     CustomId : this.CustomInfo.CustomId,
    //     CorpId : this.CustomInfo.CorpId,
    //     State : "ALL",
    //     Sort : "ALL",
    //     ReqPriod : "29",
    //     ApplyDate : false,
    //   }

    //   axios
    //     .post(BasicInfo.VUE_APP_UIL_API + "GetReqLog", posData, {
    //       headers: {
    //        "Authorization": this.CustomInfo.Token
    //       }
    //     })
    //     .then(res => {
    //       if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
    //       if (res.data.ResultCd === "00") {
    //         for(let k = 0; k < res.data.Result.length; k ++){
    //           res.data.Result[k].sNum = k + 1
    //         }
    //         this.Records = res.data.Result
    //       } else {
    //         EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
    //       }
    //     })
    //     .catch(err => {
    //       EventBus.$emit("onShowMsg",true, ""+err);        
    //     });
    // },

    bCheckEmployeeTrainingFile() {
      for (let i = 0; i < this.zWorker.length; i++) {
        if (this.zWorker[i].cEmployeeTrainingFileId == "NONE") {
          return false;
        }        
      }
      return true;
    },

    isValidDate(inputDate) {
      

      const date = new Date(inputDate); // 입력된 날짜
      const currentDate = new Date(); // 현재 날짜
      const currentYear = currentDate.getFullYear(); // 현재 연도
      const inputYear = date.getFullYear(); // 입력된 연도

      // 입력된 날짜가 현재 연도 이상이면 true
      if (inputYear >= currentYear) {
        return true;
      }

      // 입력 연도 + 1년을 계산
      const nextYearDate = new Date(date);
      nextYearDate.setFullYear(inputYear + 1);

      // 현재 날짜가 6월 이전인지 확인
      const isBeforeJune = currentDate.getMonth() < 6; // 0부터 시작하므로 5는 6월

      console.log(nextYearDate.getFullYear(), currentYear, isBeforeJune);
      // 입력일자 + 1년이 현재 연도에서 6월 이전이면 true
      return nextYearDate.getFullYear() === currentYear && isBeforeJune;
    },

    bCheckEmployeeTrainingNum() {
      for (let i = 0; i < this.zWorker.length; i++) {
        console.log(this.zWorker[i].cEmployeeTrainingNum, this.zWorker[i].cEmployeeTrainingDate);
        if (this.zWorker[i].cEmployeeTrainingNum == "") {
          return false;
        }
        if (this.zWorker[i].cEmployeeTrainingDate == "") {
          return false;
        }
        if (!this.isValidDate(this.zWorker[i].cEmployeeTrainingDate)) {
          return false;
        }
      }
      return true;
    },

    bCheckConstructionFile() {
      for (let i = 0; i < this.zWorker.length; i++) {
        console.log(this.zWorker[i].cConstructionDate);
        if (this.zWorker[i].cConstructionFileId == "NONE") {
          return false;
        }   
      }
      return true;
    },

    bCheckConstructionFileDate() {
      for (let i = 0; i < this.zWorker.length; i++) {
        console.log(this.zWorker[i].cConstructionDate);
        if (this.zWorker[i].cConstructionDate == "" || this.zWorker[i].cConstructionDate == null) {
          return false;
        }
      }
      return true;
    },

    SetReqLog(){
      if (this.CustomInfo.SiteId == "SKMG14" || this.CustomInfo.SiteId == "SKTC") {               
        if (this.editedItem.cPurpose == "공사" || this.editedItem.cPurpose == "유지보수") {
          // check..
          if (!this.bCheckEmployeeTrainingFile()) {
            EventBus.$emit("onShowMsgBox", "확인","종사자 교육 이수증이 첨부되지 않았습니다.");    
            return;
          }
          if (!this.bCheckEmployeeTrainingNum()) {
            EventBus.$emit("onShowMsgBox", "확인","이수일자/이수번호가 입력되지 않았습니다.(유효한 이수일자인지 확인하세요.)");    
            return;
          }
        }

        if (this.editedItem.cPurpose == "공사") {
          if (!this.bCheckConstructionFile()) {
            EventBus.$emit("onShowMsgBox", "확인","건설업 기초안전보건교육 이수증이 첨부되지 않았습니다");    
            return;
          }
          if (!this.bCheckConstructionFileDate()) {
            EventBus.$emit("onShowMsgBox", "확인","건설업 기초안전보건교육 이수일자가 입력되지 않았습니다.");    
            return;
          }
        }
      }

      if (this.editedItem.cSort == "1" && (this.CustomInfo.FileId == "NONE" || this.CustomInfo.FileId == "")) {
        this.bShowMsg = true
        this.cCircularTime = 0;
        this.CountTime();
        setTimeout(() => {
          clearInterval(this.interval)
          this.bShowMsg = false
          this.$router.push({name : "ChangeCustomInfo"})
        }, 3000);
        return
      }

      if (this.zChargeInfo.cUserId == "") {
        EventBus.$emit("onShowMsgBox", "담당자가 선택 되지 않았습니다.","검색 아이콘을 클릭 하여 담당자를 검색 및 선택하여 주세요.");
        this.$refs.ChargeInfoRef.focus();
        return
      }
      if (this.editedItem.cPurpose == "") {
        EventBus.$emit("onShowMsgBox", "필수 선택 사항이 누락되었습니다.","방문 목적을 선택하여 주세요.");        
        return
      }
      if (this.editedItem.cPurpose != "직접입력" && this.editedItem.cSubPurpose == "") {
        EventBus.$emit("onShowMsgBox", "필수 선택 사항이 누락되었습니다.","방문 목적에 대한 부가 설명을 입력하여 주세요.");
        this.$refs.SubPurposeRef.focus();
        return
      }

      if (this.editedItem.cPurpose != "직접입력" && this.editedItem.cSubPurpose.length > 50) {
        EventBus.$emit("onShowMsgBox", "필수 선택 사항이 누락되었습니다.","방문 목적에 대한 부가 설명은 50자를 넘길 수 없습니다.");
        return
      }
      
      if (this.editedItem.cPurpose == "직접입력" && this.editedItem.cDirPurpose == "") {
        EventBus.$emit("onShowMsgBox", "필수 입력 사항이 누락되었습니다.","방문 목적을 입력하여 주세요.");
        return
      }

      if (this.editedItem.cSort == "ALL") {
        EventBus.$emit("onShowMsgBox", "필수 선택 사항이 누락되었습니다.","구분 항목을 선택하여 주세요.");
        return
      }

      if (this.editedItem.cSort == "0" && this.editedItem.cStartDate != this.editedItem.cEndDate) {
        EventBus.$emit("onShowMsgBox", "필수 선택 사항이 누락되었습니다.","일반 방문할 날짜를 선택 하여 주세요.");
        return
      }

      if (this.cDefaultSiteMap == "") {
        if (this.editedItem.cZone == "") {
          EventBus.$emit("onShowMsgBox", "필수 선택 사항이 누락되었습니다.","방문장소를 선택하여 주세요.");
          return
        }        
      }


      if (this.zWorker.length == 0) {
        EventBus.$emit("onShowMsgBox", "필수 선택 사항이 누락되었습니다.","방문자는 최소 1명 이상 선택하여 주세요.");
        return
      }

      

      if (this.editedItem.cPurpose == "직접입력") this.editedItem.cPurpose = this.editedItem.cDirPurpose;

      var posData = {}
      var zWorker = []

      for(let k = 0; k < this.zWorker.length; k ++){
        zWorker.push({
          CustomId : this.zWorker[k].CustomId,
          CustomNm : this.zWorker[k].CustomNm
        })
      }

      posData = {
        ReqId : "",
        SiteId : this.CustomInfo.SiteId,
        CustomId : this.CustomInfo.CustomId,
        CustomNm : this.CustomInfo.CustomNm,
        CorpNm : Util.ChangeCorpNm3Data(this.CustomInfo.Local,this.CustomInfo.CorpNmKor,this.CustomInfo.CorpNmEng),
        CorpId : this.CustomInfo.CorpId,
        Manager : this.CustomInfo.Manager,
        StartDate : this.editedItem.cStartDate,
        EndDate : this.editedItem.cEndDate,
        Purpose : this.editedItem.cPurpose,
        SubPurpose : this.editedItem.cSubPurpose,
        CarType : this.editedItem.cCarType,
        CarNo : this.editedItem.cCarNo,
        ChargeUserId : this.zChargeInfo.cUserId,
        ChargeUserNm : this.zChargeInfo.cUserNm,
        Zone : this.editedItem.cZone,
        MapTreeInfo : Util.ChangeArray(this.zMapZoneInfo),
        Sort : this.editedItem.cSort,
        ChargeEmail : Util.AddEmail1and2(this.zChargeInfo.cEmailAddr1,this.zChargeInfo.cEmailAddr2),
        WorkerInfo : zWorker,
        ReqMsg : this.editedItem.cReqMsg,
        CarInfo : this.zCarInfo,
      }


      if (this.cDefaultSiteMap != "") {
        posData.Zone = "사업장전체";        
        posData.MapTreeInfo = [{id:this.cDefaultSiteMap}];

        // console.log("maptree", posData.Zone)
      }
      

      axios
        .post(process.env.VUE_APP_UIL_API + "SetReqLog", posData, {
          headers: {
           "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd == "66") { EventBus.$emit("onChangeCorpInfo"); return; }
          if (res.data.ResultCd === "00") {

            if (this.CustomInfo.SiteId == "SKMG14" || this.CustomInfo.SiteId == "SKMJ") {
              EventBus.$emit("onShowMsg2","확인","방문예약이 완료되었습니다.<br>방문하실 때 노트북, 태블릿 등을 휴대하실 경우 반드시 업체물품 반입신청을 별도로 하셔야 합니다.");              
            } else {
              EventBus.$emit("onShowMsg",false,  "방문예약이 완료되었습니다.");
            }

            
            // for(let k=0;k <this.Records.length;k++){
            //   this.Records[k].sNum = this.Records[k].sNum+1
            // }
            // res.data.Result[0].sNum = 1

            // this.Records.unshift(res.data.Result[0])

            this.editedItem  = Object.assign({}, this.defaultItem);

            this.zMapZoneInfo = [];
            this.zWorker = [];

            this.init();
            this.editedItem.cCarType = this.CustomInfo.CarType
            this.editedItem.cCarNo = this.CustomInfo.CarNo
          } else if (res.data.ResultCd == "06") {
            EventBus.$emit("onShowMsgBox","출입이 불가한 신청자가 있습니다.", "방문자 목록을 새로 고침 하여 상세한 내용을 확인하여 주세요.");
          } else if (res.data.ResultCd == "55") {
            EventBus.$emit("onShowMsgBox","출입 정지 기간 중입니다.", res.data.Msg);
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);        
        });
    },

    // // 방문 신청 현황 삭제하기
    // DelReqLog(index,item) {
    //   var posData = {
    //     CustomId : item.cCustomId,
    //     ReqId : item.cReqId,
    //     CorpId : this.CustomInfo.CorpId,
    //   };

    //   axios
    //     .post(BasicInfo.VUE_APP_UIL_API + "DelReqLog", posData, {
    //       headers: {
    //        "Authorization": this.CustomInfo.Token
    //       }
    //     })
    //     .then(res => {
    //       if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
    //       if (res.data.ResultCd == "66") { EventBus.$emit("onChangeCorpInfo"); return; }
    //       if (res.data.ResultCd === "00") {
    //         this.Records.splice(index, 1);
    //         for (let i = 0; i < this.Records.length;i ++){
    //           this.Records[i].sNum = i+1
    //         }
    //         EventBus.$emit("onShowMsg",false,  "삭제되었습니다.");
    //       } else {
    //         EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
    //       }
    //     })
    //     .catch(err => {
    //       EventBus.$emit("onShowMsg",true, ""+err);        
    //     });
    // },

    // // 데이터 테이블 내부 데이터 클릭 시
    // handleClick(value) {
    //   this.selected = [value];
    // },

    // // 데이터 테이블 목록 두 번 클릭 시 실행 함수
    // // 수정 다이올로그 창 열기
    // handleDoubleClick(item) {
    //   if (this.CustomInfo.CorpId != item.cCorpId) return

    //   if (this.selected.length > 0 || item.cReqId != undefined){
    //     this.OpenDialog(this.selected[0]);
    //     // this.$refs.EditDialogRef.ShowDialog(item,this.Records.indexOf(item));
    //   }
    // },

    // OpenDialog(item) {
    //   if (item.cState == BasicInfo.REQ_TYPE_VISIT_STATE_REQ) {
    //     let EditIndex = this.Records.indexOf(item);
    //     this.$refs.EditDialogRef.ShowDialog(item,EditIndex);
    //   } else {
    //     this.ShowComment(item,item.cState)
    //   }
    // },

    // ShowComment(oitem,StateNm) {
    //   this.$refs.ResponseDialogRef.ShowDialog(oitem,this.getState(StateNm),true)
    // },

    // ChangeReq(item,index){
    //   this.Records.splice(index,1,item[0])
    // },

    SetAddWorker() {
      if (this.editedItem.cStartDate == "" || this.editedItem.cEndDate == "") {
        EventBus.$emit("onShowMsgBox","필수 입력 사항이 누락 되었습니다.","방문 시작일과 종료일을 선택 하여 주세요.");
        return
      }

      this.$refs.AddWorkerDialogRef.ShowDialog(this.editedItem,this.zWorker)
    },

    SelectWorker(zData){
      this.zWorker = [];
      
      for(var i = 0; i < zData.length; i++){
        this.zWorker.push(zData[i])
        // if (zData[i].CustomId != this.CustomInfo.CustomId) {
        //   this.zWorker.push(zData[i])
          
        //   // if (i != zData.length-1) {
        //   //   this.editedItem.cWorkerList = this.editedItem.cWorkerList + zData[i].CustomNm
        //   // } else {
        //   //   this.editedItem.cWorkerList = this.editedItem.cWorkerList + zData[i].CustomNm + ","
        //   // }
        // }
      }      
    },

    AddEmployeeTrainingFileId(item) {      
      this.isConstructionMode = false;
      this.SelItem = item;
      this.$refs.fileInput.click();
    },
    DelEmployeeTrainingFileId(item) {
      var posData = {        
        SiteId : this.CustomInfo.SiteId,
        CustomId : item.cCustomId,        
      }
      axios
        .post(process.env.VUE_APP_UIL_API + "DelEmployeeTrainingFileId", posData, {
          headers: {
           "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd == "66") { EventBus.$emit("onChangeCorpInfo"); return; }
          if (res.data.ResultCd === "00") {
            item.cEmployeeTrainingFileId = "NONE";            
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);        
        });
    },
    AddConstructionFileId(item) {      
      this.isConstructionMode = true;
      this.SelItem = item;
      this.$refs.fileInput.click();
    },
    DelConstructionFileId(item) {
      var posData = {        
        SiteId : this.CustomInfo.SiteId,
        CustomId : item.cCustomId,        
      }

      axios
        .post(process.env.VUE_APP_UIL_API + "DelConstructionFileId", posData, {
          headers: {
           "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd == "66") { EventBus.$emit("onChangeCorpInfo"); return; }
          if (res.data.ResultCd === "00") {
            item.cConstructionFileId = "NONE";            
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);        
        });
    },

    GetEmployeeTrainingDate(item) {
      this.SelItem = item;
      this.dateType = 'employeeTraining'; 
      this.isDate = true;
      this.pickerDate = item.cEmployeeTrainingDate;
    },

    GetConstructionDate(item) {
      this.SelItem = item;
      this.dateType = 'construction';
      this.isDate = true;
      this.pickerDate = item.cConstructionDate;
    },

    setDate(){
      this.isDate = false;
       // 날짜 타입에 따라 다르게 처리
      if (this.dateType == 'employeeTraining') {
        this.SelItem.cEmployeeTrainingDate = this.pickerDate;
        this.SetEmployeeTraining(this.SelItem);
      } else if (this.dateType == 'construction') {
        this.SelItem.cConstructionDate = this.pickerDate;
        this.SetConstructionFile(this.SelItem);
      }
    },


    onInputChange(item) {
      // 기존 타이머 제거
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }

      // 1초 후 저장
      this.timeoutId = setTimeout(() => {
        this.SetEmployeeTraining(item);  
        this.SetConstructionFile(item);        
      }, 1000);
    },

    SetEmployeeTraining(item) {
      var posData = {        
        SiteId : this.CustomInfo.SiteId,
        CustomId : item.CustomId,        
        cEmployeeTrainingFileId : item.cEmployeeTrainingFileId,        
        cEmployeeTrainingDate : item.cEmployeeTrainingDate,        
        cEmployeeTrainingNum : item.cEmployeeTrainingNum,        
      }

      axios
        .post(process.env.VUE_APP_UIL_API + "SetEmployeeTraining", posData, {
          headers: {
           "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd == "66") { EventBus.$emit("onChangeCorpInfo"); return; }
          if (res.data.ResultCd === "00") {
            //        
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);        
        });
    },
    SetConstructionFile(item) {
      var posData = {        
        SiteId : this.CustomInfo.SiteId,
        CustomId : item.CustomId,        
        cConstructionFileId : item.cConstructionFileId,
        cConstructionDate : item.cConstructionDate,         
      }

      axios
        .post(process.env.VUE_APP_UIL_API + "SetConstructionFile", posData, {
          headers: {
           "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd == "66") { EventBus.$emit("onChangeCorpInfo"); return; }
          if (res.data.ResultCd === "00") {
            //        
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);        
        });
    },

    async onFileSelected(event) {
      const file = event.target.files[0]; // 선택된 파일
      if (file) {
        this.NowSelFile = file;       

        var res = await this.bSendSvrFile();
        if (res.data.ResultCd == "00") {
          if (!this.isConstructionMode) {
            this.SelItem.cEmployeeTrainingFileId = res.data.FileId;
            this.SetEmployeeTraining(this.SelItem);
          } else {
            this.SelItem.cConstructionFileId = res.data.FileId;
            this.SetConstructionFile(this.SelItem);
          }
        } else {
          EventBus.$emit("onShowMsg",true, "파일 저장에 실패하였습니다. 관리자에게 문의 바랍니다.");
          this.loading = false;
          return;
        }        
      }
    },


    // 파일 저장하기
    bSendSvrFile(){
      var d = new Date();
      var Year = d.getFullYear(); 
      
      var fileName = this.NowSelFile.name;
      var Extend = Util.getExtension(fileName).toUpperCase();
      var sFileTypeId = Util.sGetId(Util.sGetFileType(this.NowSelFile.type));
        
      let formData = new FormData();
      formData.append('uploadfile', this.NowSelFile);
      return new Promise((resolve) => (
        axios.post(process.env.VUE_APP_UIL_API + "UploadFile?PublicFile=Y&Year="+Year+"&FileNm="+fileName+"&Extend="+Extend+"&MimeType="+this.NowSelFile.type+"&Size="+this.NowSelFile.size+"&FileTypeId="+sFileTypeId+"&SiteId="+this.$store.state.CustomInfo.SiteId,
                formData,
                {
                headers: {
                  // "Authorization" : this.CustomInfo.Token,
                  'Content-Type' : 'multipart/form-data',
                }
              }
            )
            .then(res => {
              resolve(res);
            })
            .catch(err =>{
              resolve(null);
              EventBus.$emit("onShowMsg",true, "파일저장에 실패하였습니다. 관리자에게 문의 바랍니다." + err)
          })
      ));
    },

    downloadPage() {
      const url = "https://edunics.me.go.kr/academy/main/main.do";
      window.open(url, "_blank"); 
    },
  }
}
</script>

<style>
  .v-progress-circular {
    margin: 1rem;
  }

  .v-text-field.essential > .v-input__control input:hover {
    /* background-color: rgb(228, 222, 222) !important; */
    color : red
  }
</style>



